import { render, staticRenderFns } from "./ProductItem1.vue?vue&type=template&id=972ba5a8&scoped=true"
import script from "./ProductItem1.vue?vue&type=script&lang=js"
export * from "./ProductItem1.vue?vue&type=script&lang=js"
import style0 from "./ProductItem1.vue?vue&type=style&index=0&id=972ba5a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972ba5a8",
  null
  
)

export default component.exports